// extracted by mini-css-extract-plugin
export var container = "FAQs-module--container--G-x9w";
export var ctas = "#226355";
export var grayBackground = "#f6f8fb";
export var title = "FAQs-module--title--iTvDI";